import { ClosureReason, SerializedWorkflowInstance } from './SerializedWorkflowInstance';

// TODO remove this function after migrating any potentially outdated serialized closureReasons (`{}`)
export function transformSerializedClosureReasons(
  closureReasons: SerializedWorkflowInstance['closureReasons'],
): ClosureReason[] {
  return Array.isArray(closureReasons) ? closureReasons : Object.values(closureReasons);
}
